/*
 * @Descripttion:
 * @version:
 * @Author: susj
 * @Date: 2022-09-22 18:15:46
 * @LastEditors: susj
 * @LastEditTime: 2022-09-22 18:18:45
 */
import { BasicLayout } from '@/components/layouts';
import permissionConst from '@/utils/const/permission';

export default {
  path: '/my-app',
  name: 'MyApp',
  component: BasicLayout,
  redirectToChild: true,
  meta: {
    title: '开发',
    authorities: permissionConst.manager,
  },
  children: [
    // {
    //   path: '/my-app/my-service',
    //   name: 'MyApp.MyService',
    //   component: () => import(/* webpackChunkName: "data" */ '@/views/modules/my-app/MyService.vue'),
    //   meta: {
    //     title: '我的服务',
    //     icon: 'icon-wodefuwu',
    //   },
    // },
    {
      path: '/my-app/developer',
      name: 'MyApp.Developer',
      component: () => import(/* webpackChunkName: "data" */ '@/views/modules/my-app/Developer.vue'),
      meta: {
        title: '账号中心',
        icon: 'icon-kaifazheshenqing',
      },
    },
    {
      path: '/my-app/app-manage',
      name: 'MyApp.AppManage',
      component: () => import(/* webpackChunkName: "data" */ '@/views/modules/my-app/AppManage.vue'),
      meta: {
        title: '应用管理',
        icon: 'icon-yingyongguanli',
      },
    },
    {
      path: '/my-app/user-list',
      name: 'MyApp.UserList',
      component: () => import(/* webpackChunkName: "data" */ '@/views/modules/my-app/UserList.vue'),
      meta: {
        title: '应用管理',
        icon: 'icon-yingyongguanli',
      },
    },
  ],
};
